import React from 'react';
import Convene from './Convene/Convene';
import Documents from './Documents/Documents';
import OrderOfTheDay from './OrderOfTheDay/OrderOfTheDay';

const DetailTabs = ({
	tab,
	session,
	user,
	canEdit,
	valOrgan,
	currentFile,
	migratedSessionPer,
}) => {
	return (
		<>
			<div className={tab === 1 ? '' : 'd-none'}>
				<OrderOfTheDay
					session={session?.id}
					user={user}
					organoId={session?.organoId}
					canEdit={migratedSessionPer === false ? migratedSessionPer : canEdit}
					dataSesAux={session}
					valOrgan={valOrgan}
					value={tab}
					index={1}
					hidden
				/>
			</div>
			<div className={tab === 2 ? '' : 'd-none'}>
				<Convene
					value={tab}
					index={2}
					session={session}
					canEdit={canEdit}
					currentFile={currentFile}
					tab={tab}
				/>
			</div>
			<div className={tab === 3 ? '' : 'd-none'}>
				<Documents value={tab} index={4} session={session} tab={tab} />
			</div>
		</>
	);
};

export default DetailTabs;
